import talentsSavedSearches from './models/TalentsSavedSearches';

export default { talentsSavedSearches };
